export default __webpack_public_path__ + "static/media/Dial_Black_Green.41d5635a.png";